<template>
  <div id="reservation">
    <van-nav-bar title="待收款订单" left-arrow @click-left="goLastPage" :border="false" />
    <div class="reservationWrap">
      <span class="tip" v-if="reservationOrderList.length == 0? true: false">你还没有待收款订单哦</span>
      <span class="tip" v-else>请耐心等待下单方打款</span>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <OrderListPublic v-for="(item,i) in reservationOrderList" :key="i" :listPublicObj="item" :toPageId="item.id" toPageName="payment_detail" />
      </van-pull-refresh>
    </div>
  </div>
</template>
<script>
import OrderListPublic from "@/components/order/OrderListPublic.vue";
import TopBar from "@/components/home/TopBar.vue";
import { Toast } from "vant";
export default {
  components: {
    OrderListPublic,
    TopBar,
  },
  data() {
    return {
      reservationOrderList: [],
      isLoading: true,
      reservationID: 0,
    };
  },
  created() {
    this.getReservationList();
  },
  methods: {
    goLastPage() {
      this.$router.go(-1);
    },
    getReservationList() {
      this.$http
        .get("/api/v2/worker/orders/service?work_status=12.13")
        .then((res) => {
          console.log("代收款订单", res);
          this.reservationOrderList = res.data.result.data;
        });
    },
    onRefresh() {
      this.getReservationList();
      setTimeout(() => {
        Toast("刷新成功");
        this.isLoading = false;
      }, 1000);
    },
  },
};
</script>
<style lang="less">
#reservation {
  .tip {
    font-size: 1.4rem;
    padding: 1rem 0;
    text-align: center;
    margin: 1rem 1rem 0 1rem;
    display: block;
    box-sizing: border-box;
    border-radius: 5px;
  }
}
</style>